import ApiClient from '@/api/ApiClient';
import { ARMADO_URL } from '@/utils/CONST';

// const client = new ApiClient('client/timeticketattachment');
const client = new ApiClient('client/timeticketattachment');

class TimeTicketAttachmentApiClient {
	static download (idsQuery: string) {
		client.windowOpen(`${ARMADO_URL}/app/client/timeticketattachment${idsQuery}&isDownload=true`, '_blank');
	}

	static view (idsQuery: string) {
		client.windowOpen(`${ARMADO_URL}/app/client/timeticketattachment${idsQuery}`, '_blank');
	}
}

export default TimeTicketAttachmentApiClient;
